import * as React from "react";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { PageTransition } from "../Spinner/PageTransition";
import { NewCoachWrapper } from "./NewCoach/NewCoachWrapper";
import { Title } from "./NewCoach/NewCoachComponents/Title";
import { Subtitle } from "./NewCoach/NewCoachComponents/Subtitle";
import { CoachSummaryTable } from "./NewCoach/NewCoachContents/CoachSummaryTable";
import Searchbar from "../Searchbar/Searchbar";
import { CompanyInterface } from "Casadesk/Entity/Entities/Company/CompanyInterface";
import { PersonInterface } from "Casadesk/Entity/Entities/Person/PersonInterface";


export class CoachUpdateCounterparty extends Component {
  public state = {
    activeStep: 0,
    skipped: new Set(),
    openCoachUpdateCounterparty: false,
    hasModifiedData: false,
    openLeavePrompt: false,
    disableButtonDuringRequest: false,
    errorFields: null,
    selectedCounterpartyForPayment: null,
    isFinishDialogOpen: false,
    isSaving: false,
    errorMessage: null,
  };

  constructor(public props) {
    super(props);
  }

  public componentWillMount() {
    this.setState({
      openCoachUpdateCounterparty: this.props.openCoachUpdateCounterparty,
    });
  }


  public clearState = () => {
    this.setState({
      activeStep: 0,
      skipped: new Set(),
      openCoachUpdateCounterparty: false,
      hasModifiedData: false,
      openLeavePrompt: false,
      disableButtonDuringRequest: false,
      errorFields: null,
      selectedCounterpartyForPayment: null,
      isFinishDialogOpen: false,
      errorMessage: null
    });
  }

  public onCloseCoach = () => {
    this.props.onCloseCoach.call(this);

    setTimeout(() => { this.clearState() }, 100);
    this.clearBackEndErrors();
  }


  /* Main logic for STEPPER */
  // Logic for stepper, use methods when we click button continue on step page, and we start logic.
  public handleNext = () => {
    const { activeStep } = this.state;
    const steps = this.getSteps();

    if (activeStep === steps.length - 1) { // it is last step
      if (this.state.errorFields?.length > 0) {
        this.setState({
          isFinishDialogOpen: true
        });
      } else {
        this.onCloseCoach();

      }
    } else {
      switch (activeStep) {
        case 0:
          return this.startStep1();
        case 1:
          return this.startStep2();
        case 2:
          return this.plusOneStep();
      }
    }
  };

  public handleBack = () => {
    const { activeStep } = this.state;

    if (activeStep === 0) {
      if (typeof this.props.openFirstStep !== "undefined") {
        this.clearFieldsError();
        this.clearBackEndErrors();
        this.clearState();
        return this.props.openFirstStep.call(this);
      }
    } else {
      this.clearFieldsError();
      return this.setState({
        activeStep: activeStep - 1,
      });
    }
  }

  public plusOneStep = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep + 1,
    });
  }

  // Here we save all steps name and get count of steps for showing user steps name.
  public getSteps = () => {
    return [
      this.trans("link/selectcounterparty"),
      this.trans("summary"),
      this.trans("menuitem-finish")
    ];
  }

  //All components with content for steps we have here
  public getStepContent = (step) => {
    switch (step) {
      case 0:
        return this.stepContent(step);
      case 1:
        return this.stepContent(step);
      case 2:
        return this.stepContent(step);
      default:
        return this.trans("unknown-step");
    }
  }

  // Content details for diffenrent steps.
  public stepContent = (step) => {
    return (
      <div>
        {step === 0 && this.firstStepDetails()}
        {step === 1 && this.secondStepDetails()}
        {step === 2 && this.thirdStepDetails()}
      </div>
    )
  }

  // Steppers components content
  public firstStepDetails = () => {
    return (
      <div className="coach-content-wrapper">
        <Title
          title={this.trans("link/selectcounterparty")}
        />
        <Subtitle
          subtitle={this.props.payment?.name}
        />

        <div className="search-bar-container" style={{ margin: "-20px 0 -10px 0" }}>
          <Searchbar
            {...this.props}
            id="selectedCounterpartyForPayment"
            className={"scroll-to-counterpartyId"}
            name={"counterparty"}
            floatingLabelText={this.trans("label-counterparty")}
            allResults={true}
            objectField={true}
            onChange={this.selectCounterpartyForPayment}
            onClear={this.clearCounterpartyForPayment}
            selectedEntity={this.state.selectedCounterpartyForPayment}
            searchParameter={"contactsSearch"}
            error={this.getErrorFor("counterpartyId")}
            showClickThroughLink={!this.props.dialogPresentation}
            searchText={this.state.selectedCounterpartyForPayment ? `${this.state.selectedCounterpartyForPayment.nameOfEntity}, ${this.state.selectedCounterpartyForPayment.displayName}` : null}
            styleInModal={"pick-object-modal"}
          />
        </div>

      </div>
    )
  }

  public secondStepSummary = () => {

    let summaryArr = [
      {
        label: this.trans("label-counterparty"),
        value: this.props.payment?.name
      },
      {
        label: this.trans("dropdown-button/newcounterparty"),
        value: this.state.selectedCounterpartyForPayment ? `${this.state.selectedCounterpartyForPayment.nameOfEntity}, ${this.state.selectedCounterpartyForPayment.displayName}` : null
      }
    ];

    return summaryArr;
  }

  public secondStepDetails = () => {
    return (
      <div className="coach-content-wrapper">
        <Title
          title={this.trans("coach/moveunit-step/second-title")}
        />

        <CoachSummaryTable
          tableRows={this.secondStepSummary()}
        />
      </div>
    )
  }

  public thirdStepDetails = () => {
    return (
      <div className="coach-content-wrapper">
        {this.state.errorFields && this.state.errorFields.length === 0 ?
          <div>

            <Title
              title={this.trans("result")}
            />
            <div style={{ display: "flex", justifyContent: "center", marginBottom: "10px" }}>
              {this.image.getAvatar("success", { size: 62 })}
            </div>
            <Subtitle
              subtitle={this.trans("coach/general-summary-update-subtitle-dutch-het", { entity: this.trans("label-counterparty").toLowerCase() })}
            />
          </div>
          :
          <div>
            <div className="info-text">
              {`${this.trans("coach/counterparty-step/third-errorinfo1")}`}
            </div>
            <div className="error-list-item">
              {
                this.state.errorFields && this.state.errorFields.map(item => {
                  let transField = this.trans(`coach-error-${item}`)

                  return <div className="success-created-entity-or-error">{this.trans("coach/owner-error/field-label", { field: transField })}</div>
                })
              }
            </div>
            <div className="info-text">
              {this.trans("coach/propertyowner-scenario/company-step/fourth-errorinfo2")}
            </div>
          </div>
        }
      </div>
    );
  }

  //Funcionality for steps
  public startStep1 = () => {
    return this.propertyStartStep1();
  }

  public startStep2 = () => {
    return this.propertyStartStep2startStep2();
  }


  //Methods for step logic
  public propertyStartStep1 = () => {
    this.plusOneStep();
  }

  public changeCounterparty = (counterpartyId) => {
    const payload: any = {
      paymentId: this.props.payment.id,
      payment: {
      }
    }

    if (this.state.selectedCounterpartyForPayment?.nameOfEntity === 'Company') {
      payload.payment.companyId = counterpartyId
      payload.payment.contactId = null
    } else if (this.state.selectedCounterpartyForPayment?.nameOfEntity === 'Person') {
      payload.payment.contactId = counterpartyId
      payload.payment.companyId = null
    }
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_PAYMENT_UPDATE_FIELD_START,
        payload: {
          ...payload
        },
        onSuccess: () => {
          this.setState({
            errorFields: [],
            isSaving: false
          });
          this.plusOneStep();
            
          return this.props.initializePage()
        
        },
        onError: (err) => {
          this.setState({
            isSaving: false,
            hasModifiedData: true,
            errorFields: err.fields,
            errorMessage: err.message,
          });
          this.plusOneStep();
        }
      });
    });
  }

  public propertyStartStep2startStep2 = () => {
    this.setState({
      isSaving: true
    })

    this.changeCounterparty(this.state.selectedCounterpartyForPayment?.id);
  }

  public propertyStartStepThird = () => {
    this.plusOneStep();
  }

  //Methods

  public clearCounterpartyForPayment = (): void => {
    this.setState({
      selectedCounterpartyForPayment: null,
      hasModifiedData: true
    });
  }
  public selectCounterpartyForPayment = (entity: CompanyInterface | PersonInterface): void => {
    this.setState({
      selectedCounterpartyForPayment: entity,
      hasModifiedData: true
    });

  }
  public clearBackEndErrors = () => {
    this.props.dispatch({
      type: Constants.PAGE_CONTACT_COMPANY_CREATE_CLEAR
    })
    this.props.dispatch({
      type: Constants.COACH_ERRORS_CLEAR
    })
  }

  public clearFieldsError = () => {
    this.setState({
      firstNameError: false,
      companyNameError: false
    })
  }

  public render() {
    const steps = this.getSteps();
    return (
      <div>

        <NewCoachWrapper
          state={this.state}
          steps={steps}
          oldCoach={true}
          content={(activeStep) => this.getStepContent(activeStep)}
          openCoach={this.state.openCoachUpdateCounterparty}
          onCloseCoach={this.onCloseCoach}
          onPageChange={(activeStep, isNext) => {
            isNext && this._handlePageChange(activeStep);
            !isNext && this.setState({ activeStep, isDisabled: false })
          }}
          showBackButton={this.state.activeStep === 1}
          disabled={false}
          disabledBack={false}
          disabledNext={!this.state.selectedCounterpartyForPayment}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}